import React from "react";
import "./whystyles.css";
import one from "./Images/one.svg";
import two from "./Images/two.svg";
import three from "./Images/three.svg";
import four from "./Images/four.svg";
import five from "./Images/five.jpg";
import six from "./Images/six.jpg";
import seven from "./Images/seven.jpg";
import eight from "./Images/eight.jpg";

const data = [
  {
    title: "Expertised Web Development",
    image: one,
    description:
      "Our team specializes in building custom, high-performance websites that cater to your business needs. We prioritize user experience and scalability, ensuring a seamless experience for both businesses and customers.",
  },
  {
    title: "Android & iOS App Development",
    image: two,
    description:
      "We develop native and cross-platform mobile applications that are reliable, scalable, and user-friendly. Our apps are designed to meet your business objectives and offer superior performance on both Android and iOS devices.",
  },
  {
    title: "Advanced Digital Marketing Strategies",
    image: three,
    description:
      "We help businesses grow through strategic Digital Marketing solutions, including SEO, SEM, SMM, and Email Marketing. Our goal is to enhance your online presence and drive targeted traffic to your website, ensuring consistent growth.",
  },
  {
    title: "Effective Customer Attraction Strategies",
    image: four,
    description:
      "Our customer funnel strategies are designed to attract, nurture, and convert potential clients. By optimizing the user journey, we ensure that each customer interaction leads to increased conversions and business growth.",
  },
  {
    title: "In-depth Analytical Business Study",
    image: five,
    description:
      "We provide detailed analytics to help businesses understand market trends, customer behavior, and performance metrics. This data-driven approach helps in making informed decisions that drive success and growth.",
  },
  {
    title: "Comprehensive Customer Support",
    image: six,
    description:
      "Our dedicated customer support team ensures that your customers receive timely assistance, enhancing customer satisfaction and loyalty. We focus on providing effective solutions for every query to maintain a positive brand image.",
  },
  {
    title: "Tailored Product Design Solutions",
    image: seven,
    description:
      "We design and develop products that are tailored to your customers' needs. By understanding the market and your target audience, we create products that resonate with users and meet business objectives efficiently.",
  },
  {
    title: "Efficient Drive for Customers",
    image: eight,
    description:
      "During high-pressure business periods, we conduct focused market research and strategize customer acquisition tactics. We ensure that once customers land on your website, they are properly guided through their journey to success.",
  },
];


export default function WHY() {
  return (
    <div style={{ marginTop: "8rem" }}>
      <center>
        <h2 style={{fontSize:"26px"}}>Our Expertise and Services</h2>
        <br />
        <div className="allgridsss">
          {data.map((item, index) => (
            <div className="grids" key={index}>
              <div className="contents">
                <span id="span_Headss">{item.title}</span>
                <br />
                <img src={item.image} id="imgtop1" alt={item.title} />
                <br />
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </center>
    </div>
  );
}
